export const themeColors = {
  background: "#131321",
  surface: "#131321",
  surface2: "#191930",
  surface3: "#121222",
  surface4: "#0f0f27",
  surfaceHover: "#32384a",
  foreground: "#f4f4f5",
  textStrong: "#ffffff",
  muted: "#a1a1aa",
  mutedDark: "#6b7280",
  line: "#1a1f2b",
  lineSoft: "#151924",
  lineStrong: "#262c39",
  lineChartVert: "#202536",
  lineChartHorz: "#191d2a",
  linePane: "#1f2430",
  neon: "#6bdcc0",
  neonArea: "#6bdcc020",
  neonTransparent: "#6bdcc000",
  success: "#75cc97",
  successDark: "#059669",
  successMarker: "rgba(117,204,151,0.65)",
  danger: "#e98188",
  dangerDark: "#dc2626",
  dangerLight: "#e98188",
  dangerArea: "#e9818820",
  dangerTransparent: "#e9818800",
  dangerMarker: "rgba(233,129,136,0.65)",
  warning: "#e8bd58",
  warningBright: "#f0ce7e",
  warningMarker: "rgba(232,189,88,0.7)",
  info: "#7eaee6",
  infoDark: "#6297d3",
  transparent: "rgba(0,0,0,0)",
  gridSoft: "#ffffff05",
  gridStrong: "#ffffff10",
  gridScene: "#333333",
  hoverSurface: "#1a1a2e",
  hoverBorder: "#ffffff20",
} as const;

export interface ThemeTokenDefinition {
  name: string;
  value: string;
  variable: string;
  description: string;
}

/**
 * The small set of tokens that define the trader shell and its semantic states.
 * Keep this list in sync with :root in styles/globals.css so the component
 * gallery can act as a useful reference for frontend work.
 */
export const themeTokenDefinitions: ThemeTokenDefinition[] = [
  {
    name: "Canvas",
    value: themeColors.background,
    variable: "--background",
    description: "The deep trading workspace background.",
  },
  {
    name: "Surface",
    value: themeColors.surface,
    variable: "--surface",
    description: "Opaque navigation, modal, and panel surfaces.",
  },
  {
    name: "Foreground",
    value: themeColors.foreground,
    variable: "--foreground",
    description: "Primary text and high-emphasis content.",
  },
  {
    name: "Neon",
    value: themeColors.neon,
    variable: "--neon",
    description: "Interactive focus, selected state, and brand accent.",
  },
  {
    name: "Success",
    value: themeColors.success,
    variable: "--success",
    description: "Connected, active, and profitable states.",
  },
  {
    name: "Warning",
    value: themeColors.warning,
    variable: "--warning",
    description: "Attention, acting-as, and degraded states.",
  },
  {
    name: "Danger",
    value: themeColors.danger,
    variable: "--danger",
    description: "Errors, losses, and destructive actions.",
  },
  {
    name: "Info",
    value: themeColors.info,
    variable: "--info",
    description: "Transport and informational status.",
  },
];

export const strategySeriesColors = [
  "#f472b6",
  "#818cf8",
  "#34d399",
  "#fbbf24",
  "#a78bfa",
  "#60a5fa",
] as const;
